import { getFormattedDateString, parseFullNameString } from '@zeta-core';

export const calculateAge = (date) => {
  if (!date) return;
  const currentDate = new Date();
  const birthDate = new Date(date);
  let age = currentDate.getFullYear() - birthDate.getFullYear();
  const month = currentDate.getMonth() - birthDate.getMonth();
  if (month < 0 || (month === 0 && currentDate.getDate() < birthDate.getDate())) {
    age--;
  }
  return `${age} years`;
};

export const getDependentDetails = (formData) => {
  const dependentDetails = formData?.dependents.map((item) => {
    const { firstName, middleName, lastName } = parseFullNameString(item.fullName);
    const obj = {
      firstName: firstName || '',
      middleName: middleName || '',
      lastName: lastName || '',
      dateOfBirth: item.dob && getFormattedDateString(item.dob, 'YYYY-MM-DD'),
      gender: item.gender?.value || '',
      schoolName: item.institution,
      costOfSchoolCurrency: item.costCurrency,
      costOfSchoolAmount: parseFloat(item.costAmount),
      startDate: item.start,
      endDate: item.end,
    };
    if (item.id) {
      obj.id = item.id;
    }
    return obj;
  });
  return dependentDetails;
};

export const getErrorFieldName = (name: string, index: number) => {
  switch (name) {
    case 'ClientDetails':
      return 'client.name';
    case 'PartnerDetails':
      return 'partner.name';
    case 'DependentDetails':
      return `dependents[${index}].fullName`;
  }
};
